/**
 * Rewrite backend absolute media URLs for the current page origin.
 * Keep search/hash so cache-bust (`?v=`) and signed-query params survive.
 */
export function rewriteMediaUrlForDisplay(url, apiBase = '') {
  if (!url || typeof url !== 'string') return url;
  const base = (apiBase || '').trim();
  if (base === '' && url.startsWith('http') && url.includes('/media/')) {
    try {
      const parsed = new URL(url);
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      return url;
    }
  }
  return url;
}
